import { useParams } from 'react-router-dom';

import { useGetPatient } from '../../components/CustomHooks/useGetPatient';
import { Loading } from '../../components/Loading/Loading';
import { AuthContext } from '../../auth';
import { useContext, useEffect, useState } from 'react';
import { Roles } from '../../data_layer/repositories/Users/UserRoles';
import FeedingsTable from '../../components/Tables/FeedingsTable';
import { useGetBiomarkersListByPatientId } from '../../components/CustomHooks/useGetBiomarkersListByPatientId';
import { BiomarkersCard } from '../../components/Cards/BiomarkersCard';
import { PatientFullDetailsCard } from '../../components/Cards/PatientFullDetailsCard';
import { PatientContext } from '../../data_layer/context/Patient/PatientContext';

export const PatientDetails = () => {

    const { patient_id: patientIdFromParams } = useParams();

    const { patients } = useContext(PatientContext) || [];

    const patientId = patients?.[0]?.id || patientIdFromParams;

    const { user } = useContext(AuthContext);

    const { patient, isLoading } = useGetPatient(patientId);

    const { biomarkers, getBiomarkers } = useGetBiomarkersListByPatientId(patientId);

    const [feedingTimestampsForComparison, setFeedingTimestampsForComparison] = useState([]);

    const [currentFeedingTimestamp, setCurrentFeedingTimestamp] = useState();

    const [selectedFeedings, setSelectedFeedings] = useState([]);

    const selectAllFeedings = () => {
        // Add all feeding timestamps to the selectedFeedings array
        const allTimestamps = patient.feedings.map(feeding => feeding.timestamp);
        setSelectedFeedings(allTimestamps);
    };

    const deselectAllFeedings = () => {
        // Clear the selectedFeedings array
        setSelectedFeedings([]);
    }

    useEffect(() => {
        //console.table(biomarkers?.feedings[0]?.biomarkers);
    }, [biomarkers])


    useEffect(() => {
        getBiomarkers();
    }, []);

    useEffect(() => {

        if (patients?.length > 1)
            setFeedingTimestampsForComparison([]);
    }, [patients]);

    const selectFeeding = (timestamp) => {
        if (selectedFeedings.includes(timestamp)) {
            // Deselect feeding by removing it from the array
            setSelectedFeedings(selectedFeedings.filter(t => t !== timestamp));
        } else {
            // Select feeding by adding it to the array
            setSelectedFeedings([...selectedFeedings, timestamp]);
        }
        //console.log("Selected Feedings: ", selectedFeedings);
    }

    return (
        <div className="neo_container">
            {
                isLoading ? <Loading isLoading={isLoading} />
                    : <>
                        {patient && user.role === Roles.Clinician && <>

                            {/* <MaturationCurveCard patient={patient}/> */}

                            {
                                patients.length === 1 && <BiomarkersCard
                                    key={`biomarkers-card`}
                                    patient={patient}
                                    biomarkers={biomarkers}
                                    feedingTimestampsForComparison={feedingTimestampsForComparison}
                                    setFeedingTimestampsForComparison={setFeedingTimestampsForComparison} />
                            }


                            {
                                patients.length < 2 && <PatientFullDetailsCard
                                    key={`patient-details-full-card`}
                                    index={0}
                                    isComparingPatients={patients.length > 1} />
                            }


                            {
                                feedingTimestampsForComparison.map((timestamp) => (
                                    <PatientFullDetailsCard
                                        index={0}
                                        key={timestamp}
                                        feedingTimestamp={timestamp} />
                                ))
                            }

                            {
                                patients.length > 1 && patients.map((patient, index) => (
                                    <PatientFullDetailsCard
                                        key={patient.patient_id}
                                        index={index}
                                        isComparingPatients={true} />
                                ))
                            }
                        </>}




                        {patient && user.role === Roles.NeoneurAdmin && <>

                            <div className='neo_card_container neo_ut_mt_24_mob'>

                                <FeedingsTable
                                    data={patient.feedings}
                                    facility={patient.facility_name}
                                    patient={patient}
                                    selectedFeedings={selectedFeedings}
                                    changeFeedingSelection={selectFeeding}
                                    selectAllFeedings={selectAllFeedings}
                                    deselectAllFeedings={deselectAllFeedings} />
                            </div>

                        </>}
                    </>
            }
        </div>
    )
}
